var _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    transform: "translate(4.499 -1031.861)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.001,
    cy: 1044.361,
    r: 12.5,
    fill: "#ffa40b",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#d97706",
    style: {
      lineHeight: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      blockProgression: "tb",
      isolation: "auto",
      mixBlendMode: "normal"
    },
    d: "M 10.878906 24.880859 A 12.5 12.5 0 0 0 11.251953 24.9375 A 12.5 12.5 0 0 0 12.5 25 A 12.5 12.5 0 0 0 13.384766 24.96875 A 12.5 12.5 0 0 0 14.625 24.818359 A 12.5 12.5 0 0 0 15.84375 24.544922 A 12.5 12.5 0 0 0 17.029297 24.150391 A 12.5 12.5 0 0 0 18.169922 23.640625 A 12.5 12.5 0 0 0 19.253906 23.017578 A 12.5 12.5 0 0 0 20.269531 22.291016 A 12.5 12.5 0 0 0 21.208984 21.466797 A 12.5 12.5 0 0 0 22.060547 20.552734 A 12.5 12.5 0 0 0 22.816406 19.558594 A 12.5 12.5 0 0 0 23.470703 18.492188 A 12.5 12.5 0 0 0 24.013672 17.367188 A 12.5 12.5 0 0 0 24.441406 16.193359 A 12.5 12.5 0 0 0 24.75 14.982422 A 12.5 12.5 0 0 0 24.9375 13.748047 A 12.5 12.5 0 0 0 24.976562 12.978516 L 20 8.0019531 L 18.910156 8.0019531 L 18 7.0917969 L 15 6.4921875 L 12.5 6.9921875 L 10 6.4921875 L 7 7.0917969 L 7 7.5019531 L 7 8.0019531 L 5 8.0019531 L 5 19.001953 L 10.878906 24.880859 z ",
    color: "#000",
    fontFamily: "sans-serif",
    fontWeight: 400,
    transform: "translate(-4.499 1031.861)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 5.0097656,1.5019531 -3,0.5996094 0,0.4101563 0,0.5 -1.99999997,0 0,11.0000002 7.99999997,0 7.0000004,0 0,-11.0000002 -2,0 0,-0.9101563 -3,-0.5996094 -2.5000004,0.5 -2.5,-0.5 z m 0,1.0195313 2,0.3984375 0,7.9824221 -2,-0.400391 -2,0.400391 0,-7.980469 2,-0.4003906 z m 5.0000004,0 2,0.3984375 0,7.9824221 -2,-0.400391 -2.0000004,0.400391 0,-7.980469 2.0000004,-0.4003906 z m -9.0000004,1.4902344 1,0 0,8.1093752 3,-0.59961 2,0.400391 0,0.199219 0,0.890625 -6,0 0,-9.0000002 z m 12.0000004,0 1,0 0,9.0000002 -6.0000004,0 0,-0.890625 0,-0.199219 2.0000004,-0.400391 3,0.59961 0,-8.1093752 z",
    color: "#000",
    fontFamily: "sans-serif",
    fontWeight: 400,
    overflow: "visible",
    transform: "translate(.491 1036.85)",
    style: {
      lineHeight: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      blockProgression: "tb",
      isolation: "auto",
      mixBlendMode: "normal"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.3a71261ed0433835773a845bebecd2b0.svg";
export { ForwardRef as ReactComponent };